"use client"

import type React from "react"
import { useRef } from "react"
import { Button } from "./ui/Button"
import { Download } from "./icons/Download"
import { Upload } from "./icons/Upload"

interface NavbarProps {
  onExport: () => void
  onImport: (event: React.ChangeEvent<HTMLInputElement>) => void
  fileName: string
  setFileName: (name: string) => void
}

export const Navbar: React.FC<NavbarProps> = ({ onExport, onImport, fileName, setFileName }) => {
  const fileInputRef = useRef<HTMLInputElement>(null)

  const handleImportClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click()
    }
  }

  return (
    <header className="bg-blue-600 text-white shadow-md">
      <div className="container mx-auto px-4 py-3">
        <div className="flex flex-col md:flex-row md:items-center md:justify-between">
          <div className="flex items-center mb-4 md:mb-0">
            <div className="text-2xl font-bold">Badkul Technology</div>
            <div className="ml-2 text-sm bg-blue-700 px-2 py-1 rounded">JSON Builder</div>
          </div>

          <div className="flex flex-col md:flex-row space-y-2 md:space-y-0 md:space-x-4">
            <div className="flex items-center">
              <label htmlFor="fileName" className="mr-2 text-sm">
                File Name:
              </label>
              <input
                type="text"
                id="fileName"
                value={fileName}
                onChange={(e) => setFileName(e.target.value)}
                className="px-2 py-1 text-gray-800 rounded text-sm w-40"
              />
            </div>

            <div className="flex space-x-2">
              <Button onClick={onExport} variant="light">
                <Download className="w-4 h-4 mr-2" />
                Export JSON
              </Button>

              <Button onClick={handleImportClick} variant="light">
                <Upload className="w-4 h-4 mr-2" />
                Import JSON
              </Button>
              <input type="file" ref={fileInputRef} onChange={onImport} accept=".json" className="hidden" />
            </div>
          </div>
        </div>
      </div>
    </header>
  )
}
